{
  "colorInputLabel": "{label}, {channelLabel}",
  "colorNameAndValue": "{name}: {value}",
  "colorPicker": "Fargevelger",
  "twoDimensionalSlider": "2D-glidebryter"
}
